<template>
  <div class="container profile-view">
    <div class="columns is-centered">
       <div class="column is-full-desktop is-three-quarters-widescreen">
        <div class="container">
          <div class="notification padding-overload">
            <figure class="image is-128x128">
              <img class="is-rounded" v-if="user.avatar" :src="user.avatar" />
              <img class="is-rounded" v-else src="@/assets/avatar.png" />
            </figure>
            <div class="tabs is-centered is-medium is-hidden-mobile">
              <ul>
                <li :class="{ 'is-active': active === 'profile' }" v-if="!isNavDisabled">
                  <router-link to="/profile">
                    <span class="icon is-small">
                      <i class="fas fa-id-badge" aria-hidden="true"></i>
                    </span>
                    <span>Account</span>
                  </router-link>
                </li>
                <li
                  :class="{ 'is-active': active === 'billing' ? true : false }"
                  v-if="!isNavDisabled"
                >
                  <router-link to="/profile/billing">
                    <span class="icon is-small">
                      <i class="fas fa-dollar-sign" aria-hidden="true"></i>
                    </span>
                    <span>Billing</span>
                  </router-link>
                </li>
                <!-- <li :class="{ 'is-active': active === 'password' }" v-if="!isNavDisabled">
                  <router-link to="/profile/password">
                    <span class="icon is-small">
                      <i class="fas fa-lock" aria-hidden="true"></i>
                    </span>
                    <span>Password</span>
                  </router-link>
                </li> -->
                <li :class="{ 'is-active': active === 'subscription' }" v-if="!isNavDisabled">
                  <router-link to="/profile/subscription">
                    <span class="icon is-small">
                      <i class="fas fa-business-time" aria-hidden="true"></i>
                    </span>
                    <span>Subscription</span>
                  </router-link>
                </li>
                <li :class="{ 'is-active': active === 'branding' }" v-if="!isNavDisabled">
                  <router-link to="/profile/branding">
                    <span class="icon is-small">
                      <i class="fas fa-palette" aria-hidden="true"></i>
                    </span>
                    <span>Branding</span>
                  </router-link>
                </li>
                <li :class="{ 'is-active': active === 'team' }" v-if="!isNavDisabled">
                  <router-link
                    :to="{ path: disableTeams ? '/upgrade' : '/profile/team' }"
                    :class="[
                      disableTeams ? ['tooltip', 'is-tooltip-left'] : ''
                    ]"
                    data-tooltip="Please contact our sales team in the live chat to gain access."
                  >
                    <span class="icon is-small">
                      <i class="fas fa-users" aria-hidden="true"></i>
                    </span>
                    <span class="mr-1">Team</span>
                    <span class="upgrade link" v-if="disableTeams">
                      <span class="icon">
                        <i class="fas fa-crown"></i>
                      </span>
                    </span>
                    <span class="tag is-primary is-light is-rounded" v-else>
                      New
                    </span>
                  </router-link>
                </li>
                <li
                  :class="{ 'is-active': active === 'payment' ? true : false }"
                  v-if="!isNavDisabled"
                >
                  <router-link to="/profile/payment">
                    <span class="icon is-small">
                      <i class="fas fa-dollar-sign" aria-hidden="true"></i>
                    </span>
                    <span>Promo Codes</span>
                  </router-link>
                </li>
              </ul>
            </div>
            <component
              class="mt-3"
              :is="activeTabComponent"
              :user-data="user"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProfileForm from '@/components/profile/ProfileForm';
import PasswordForm from '@/components/profile/PasswordForm';
import PaymentForm from '@/components/profile/PaymentForm';
import SubscriptionForm from '@/components/profile/SubscriptionForm';
import BrandingForm from '@/components/profile/BrandingForm';
import TeamForm from '@/components/profile/TeamForm';
import Checkout from '@/components/profile/Checkout';
import BillingPortal from '@/components/profile/Billing';
export default {
  name: 'Profile',
  data() {
    return {
      active: this.$route.params.tab || 'profile',
      activeTabComponent: null
    };
  },
  watch: {
    $route: function() {
      this.active = this.$route.params?.tab || 'profile';
    },
    active: {
      immediate: true,
      handler: function(newVal) {
        if (!newVal) {
          return;
        }
        switch (newVal) {
          case 'profile':
            this.activeTabComponent = ProfileForm;
            break;
          case 'password':
            this.activeTabComponent = PasswordForm;
            break;
          case 'payment':
            this.activeTabComponent = PaymentForm;
            break;
          case 'subscription':
            this.activeTabComponent = SubscriptionForm;
            break;
          case 'branding':
            this.activeTabComponent = BrandingForm;
            break;
          case 'team':
            this.activeTabComponent = TeamForm;
            break;
          case 'checkout':
            this.activeTabComponent = Checkout;
            break;
          case 'billing':
            this.activeTabComponent = BillingPortal;
            break;
        }
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
    isNavDisabled() {
      return this.$store.getters['auth/getNavDisabledStatus'];
    },
    isDesktop() {
      return window.innerWidth > 1023;
    },
    disableTeams() {
      let accessLevel = this.$store.getters['auth/getAccessLevel'];
      // The result is inverted.
      return !(parseInt(accessLevel?.users?.value, 10) > 1 || false);
    }
  },
  created() {
    this.fetchUserData();
    if(this.active === 'checkout'){
      this.$store.commit('auth/setPreviousURL', window.location.href.split(window.location.origin)[1]);
    }
  },
  methods: {
    fetchUserData() {
      this.$store.dispatch('auth/fetchUser');
    }
  }
};
</script>
<style lang="scss" scoped>
.padding-overload {
  padding: 1.25rem 1.5rem;
}
figure {
  margin-left: auto;
  margin-right: auto;
}
.tabs {
  margin-top: 15px;
  a {
    padding: 0.5em 0.75em;
  }
}
</style>
